import { aplicarLogoEmpresa, reiniciarTenantNube, saveData } from "../core/cloudSync.js";
import { DEFAULT_ALERT_CONFIG, DEFAULT_IA_CONFIG, EMPRESA, EMPRESA_DEFAULT, KEYS, PUC_DEFAULT } from "../core/config.js";
import { exportJSON } from "../ui/actions.js";
import { navigateTo, render } from "../ui/app.js";

import { C } from "../core/config.js";
import { state } from "../core/state.js";
import { btnStyle } from "../core/utils.js";

export function getLocalStorageUsage() {
  let totalBytes = 0;
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const val = localStorage.getItem(key) || "";
      totalBytes += (key.length + val.length) * 2; // UTF-16 = 2 bytes/char
    }
  } catch {}
  return totalBytes;
}

export function renderRespaldos() {
  const stats = [
    { label:"Clientes", count:state.data.clientes.length, icon:"👥" },
    { label:"Proveedores", count:state.data.proveedores.length, icon:"🏭" },
    { label:"Productos", count:state.data.productos.length, icon:"📦" },
    { label:"Cotizaciones", count:state.data.cotizaciones.length, icon:"📋" },
    { label:"Órd. Producción", count:state.data.pedidos.length, icon:"🔧" },
    { label:"Órd. Compra", count:state.data.ocp.length, icon:"🛒" },
    { label:"Remisiones", count:state.data.remisiones.length, icon:"📮" }
  ];

  const statsHTML = stats.map(s => `
    <div style="padding:9px;background:#f8fafc;border-radius:6px;text-align:center;">
      <div style="font-size:17px;margin-bottom:4px;">${s.icon}</div>
      <div style="font-size:17px;font-weight:800;color:${C.mathiz};">${s.count}</div>
      <div style="font-size:10.5px;color:${C.muted};font-weight:600;">${s.label}</div>
    </div>
  `).join("");

  // Indicador de uso de almacenamiento
  const usedBytes = getLocalStorageUsage();
  const limitBytes = 5 * 1024 * 1024; // 5 MB límite típico
  const usedKB = (usedBytes / 1024).toFixed(0);
  const usedMB = (usedBytes / 1024 / 1024).toFixed(2);
  const pct = Math.min(100, (usedBytes / limitBytes) * 100);
  const barColor = pct > 80 ? C.red : pct > 60 ? C.amber : "#10b981";
  const storageAlerta = pct > 80 ? `
    <div style="margin-top:10px;padding:7px 10px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;font-size:11.5px;color:#dc2626;font-weight:600;">
      ⚠️ Caché local al ${pct.toFixed(0)}% — los datos siguen seguros en la nube, pero este navegador podría dejar de guardar la copia local.
    </div>
  ` : "";

  // Último backup
  let ultimoBackup = "";
  try {
    const last = localStorage.getItem("erp:last_backup");
    if (last) ultimoBackup = `<div style="font-size:10.5px;color:${C.muted};margin-top:4px;">Último respaldo exportado: <strong>${new Date(last).toLocaleString("es-CO")}</strong></div>`;
    else ultimoBackup = `<div style="font-size:10.5px;color:${C.red};margin-top:4px;">⚠️ Aún no has exportado ningún respaldo en este navegador.</div>`;
  } catch {}

  const storageBar = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 12px;font-size:12px;color:${C.text};display:flex;justify-content:space-between;align-items:center;">
        <span>💾 Caché local del navegador</span>
        <span style="font-size:12px;font-weight:600;color:${barColor};">${usedMB} MB / ~5 MB</span>
      </h3>
      <div style="background:#f1f5f9;border-radius:999px;height:14px;overflow:hidden;">
        <div style="height:100%;width:${pct.toFixed(1)}%;background:${barColor};border-radius:999px;transition:width .4s;"></div>
      </div>
      <div style="font-size:10.5px;color:${C.muted};margin-top:6px;">${usedKB} KB usados de ~5120 KB (${pct.toFixed(1)}%) — los datos viven en la nube (Supabase); esto es solo la copia local de este navegador</div>
      ${storageAlerta}
      ${ultimoBackup}
    </div>
  `;

  return `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;padding-bottom:10px;border-bottom:3px solid ${C.gold};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">Respaldos</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">Exporta e importa tus datos</p>
        </div>
      </div>
    </div>
    ${storageBar}
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 12px;font-size:12px;color:${C.text};">📊 Estado actual</h3>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:9px;">
        ${statsHTML}
      </div>
    </div>
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:10px;">
      <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;">
        <h3 style="margin:0 0 8px;font-size:12px;color:${C.text};">💾 Exportar respaldo</h3>
        <p style="font-size:12px;color:${C.muted};margin-bottom:9px;">Descarga todos tus datos en un archivo JSON.</p>
        <button data-action="export-json" style="${btnStyle(C.purple)}">⬇️ Descargar respaldo JSON</button>
      </div>
      <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;">
        <h3 style="margin:0 0 8px;font-size:12px;color:${C.text};">📥 Importar respaldo</h3>
        <p style="font-size:12px;color:${C.muted};margin-bottom:9px;">Restaura tus datos desde un archivo JSON.</p>
        <input type="file" accept=".json" id="import-file" style="display:block;font-size:12px;"/>
      </div>
    </div>
  `;
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "limpiar-documentos": (d, el, e) => {{
      if (state.usuarioRol && state.usuarioRol !== "admin") { alert("⚠️ Solo un administrador puede borrar todos los documentos."); return; }
      if (!confirm("⚠️ ¿Borrar TODOS los documentos (cotizaciones, pedidos, facturas, asientos, inventario)? Esta acción no se puede deshacer.")) return;
      saveData("cotizaciones", []);
      saveData("pedidos", []);
      saveData("ocp", []);
      saveData("remisiones", []);
      saveData("facturas", []);
      saveData("notas_credito", []);
      saveData("cuentas_pagar", []);
      saveData("cuentas_cobro", []);
      saveData("asientos", []);
      saveData("inventario", []);
      state.data.cotizaciones = []; state.data.pedidos = []; state.data.ocp = [];
      state.data.remisiones = []; state.data.facturas = []; state.data.notas_credito = [];
      state.data.asientos = []; state.data.inventario = [];
      try { localStorage.removeItem("erp:page"); } catch(e){}
      alert("✅ Todos los documentos han sido eliminados.");
      render();
      return;
    }},
  "limpiar-maestros": (d, el, e) => {{
      if (state.usuarioRol && state.usuarioRol !== "admin") { alert("⚠️ Solo un administrador puede borrar los maestros."); return; }
      if (!confirm("⚠️ ¿Borrar TODOS los maestros (clientes, proveedores, productos, empleados)? Esta acción no se puede deshacer.")) return;
      saveData("clientes", []); saveData("proveedores", []); saveData("productos", []);
      saveData("empleados", []);
      state.data.clientes=[]; state.data.proveedores=[]; state.data.productos=[];
      state.data.empleados=[];
      // PUC: no se toca — es configuración contable, no dato operativo
      state.modal = null;
      alert("✅ Maestros eliminados correctamente. El Plan de Cuentas se conserva.");
      render();
      return;
    }},
  "limpiar-todo": async (d, el, e) => {{
      if (state.usuarioRol && state.usuarioRol !== "admin") { alert("⚠️ Solo un administrador puede borrar todos los datos."); return; }
      if (!confirm("⚠️ ¿Borrar TODOS los datos y reiniciar?\n\nSe eliminarán de este navegador Y de la nube:\n• Documentos (cotizaciones, órdenes, remisiones, facturas, notas crédito)\n• Maestros (clientes, proveedores, productos, empleados)\n• Contabilidad (asientos) e inventario\n• Nómina, activos fijos y resoluciones DIAN\n• Alertas enviadas\n• TODA la configuración: datos de la empresa, logo, parámetros fiscales y de nómina, tabla de comisiones, alertas y facturación electrónica\n\nAdemás, los consecutivos de documentos volverán a empezar desde cero, se levantará el cierre contable y la Puesta en Marcha volverá al 0%. El Plan de Cuentas se restaura al estándar Decreto 2650. Los usuarios y sus roles de acceso se conservan.\n\nEsta acción no se puede deshacer.")) return;
      // Primero la nube: si falla, no se borra nada y el usuario se entera.
      try {
        await reiniciarTenantNube();
      } catch (err) {
        alert(`❌ No se pudo reiniciar el sistema en la nube:\n${err.message}\n\nNo se borró nada. Verifica tu conexión e intenta de nuevo.\n\nSi el error indica que la función reiniciar_tenant no existe, ejecuta el script supabase/2026-07-23_reiniciar_tenant.sql en Supabase.`);
        return;
      }
      // Local: vaciar TODAS las colecciones registradas en KEYS (sin listas a mano)
      Object.entries(KEYS).forEach(([k, sk]) => {
        state.data[k] = [];
        try { localStorage.setItem(sk, "[]"); } catch(e){}
      });
      // Configuraciones: borrar el caché local (la nube ya quedó limpia vía RPC)
      // para que la Puesta en Marcha arranque en 0%. Los roles personalizados
      // se conservan: son seguridad de acceso, no datos de la operación.
      ["erp:empresa_config", "erp:alert_config", "erp:ia_config", "erp:parametros_fiscales",
       "erp:parametros_nomina", "erp:tabla_comisiones", "erp:puesta_en_marcha",
       "erp:dataico_config", "erp:last_backup", "erp:page"].forEach(sk => {
        try { localStorage.removeItem(sk); } catch(e){}
      });
      // Estado en memoria: volver a los valores de fábrica
      Object.keys(EMPRESA).forEach(k => delete EMPRESA[k]);
      Object.assign(EMPRESA, EMPRESA_DEFAULT, { responsabilidades: [] });
      aplicarLogoEmpresa();
      state.alertConfig = { ...DEFAULT_ALERT_CONFIG };
      state.iaConfig = { ...DEFAULT_IA_CONFIG };
      // PUC: restaurar a base completa (nunca se borra — es configuración contable).
      // El snapshot de nube quedó vacío, así que este saveData re-sube el PUC completo.
      state.data.puc = PUC_DEFAULT.map(c => ({ ...c }));
      saveData("puc", state.data.puc);
      state.modal = null;
      alert("✅ Sistema reiniciado por completo (navegador y nube).\n\n• Todos los datos y configuraciones fueron eliminados\n• Los consecutivos vuelven a empezar desde cero\n• La Puesta en Marcha arranca en 0%\n• El Plan de Cuentas fue restaurado al estándar Decreto 2650\n• Los usuarios y sus roles de acceso se conservaron");
      render();
      return;
    }},
  "info-almacenamiento": (d, el, e) => {{
      alert(`📦 INFORMACIÓN DE ALMACENAMIENTO\n\nFuente de verdad: Nube (Supabase)\nCaché local: LocalStorage del navegador\n\nCómo funciona:\n☁️ Todos los datos y configuraciones se guardan en la nube y se sincronizan en tiempo real entre dispositivos y usuarios\n💾 El navegador guarda una copia local solo para abrir más rápido\n🔄 Si limpias el caché del navegador, los datos se descargan de nuevo de la nube al iniciar sesión\n\nRecomendación: descarga igualmente un respaldo JSON periódico como copia de seguridad adicional.`);
      return;
    }},
  "verificar-integridad": (d, el, e) => {{
      let errores = 0;
      let advertencias = 0;
      
      // Verificar referencias
      (state.data.cotizaciones || []).forEach(ct => {
        if (!ct.id) errores++;
      });
      (state.data.pedidos || []).forEach(op => {
        if (!op.id) errores++;
        if (!op._origen) advertencias++;
      });
      (state.data.remisiones || []).forEach(rc => {
        if (!rc.id) errores++;
        if (!rc._origen) errores++;
      });
      
      alert(`✅ VERIFICACIÓN DE INTEGRIDAD\n\nErrores encontrados: ${errores}\nAdvertencias: ${advertencias}\n\n${errores === 0 ? "✅ Sistema íntegro\n\nTodos tus documentos están correctamente guardados." : "⚠️ Se encontraron algunos problemas.\n\nConsider hacer un backup."}`);
      return;
    }},
  "regenerar-indices": (d, el, e) => {{
      // Regenerar índices simples (en este caso, solo recalcular datos)
      render();
      alert("✅ Índices regenerados\n\nSistema optimizado y listo para usar.");
      return;
    }},
  "ir-respaldos": (d, el, e) => {{
      navigateTo("respaldos");
      return;
    }},
  "ejecutar-limpieza": (d, el, e) => {{
      if (state.usuarioRol && state.usuarioRol !== "admin") { alert("⚠️ Solo un administrador puede ejecutar esta limpieza."); return; }
      if (!confirm("⚠️ ¿Eliminar permanentemente todos los documentos y registros contables? Esta acción no se puede deshacer.")) return;
      saveData("cotizaciones", []);
      saveData("pedidos", []);
      saveData("ocp", []);
      saveData("remisiones", []);
      saveData("facturas", []);
      saveData("notas_credito", []);
      saveData("cuentas_pagar", []);
      saveData("cuentas_cobro", []);
      saveData("asientos", []);
      saveData("inventario", []);
      try {
        localStorage.removeItem(KEYS.cotizaciones);
        localStorage.removeItem(KEYS.pedidos);
        localStorage.removeItem(KEYS.ocp);
        localStorage.removeItem(KEYS.remisiones);
        localStorage.removeItem(KEYS.facturas);
        localStorage.removeItem(KEYS.notas_credito);
        localStorage.removeItem(KEYS.asientos);
        localStorage.removeItem(KEYS.inventario);
      } catch {}
      state.modal = null;
      alert("🗑️ Todos los documentos y registros contables han sido eliminados permanentemente.\nLos maestros (Clientes, Proveedores, Productos, Vendedores) se conservaron.");
      render();
      return;
    }},
  "export-json": (d, el, e) => {exportJSON();
      return;},
});
